export const getRejectionData = (acceptations, rejectionDataHistory) => {
  const currentRejection =
    acceptations?.data?.decision === "Rejected" ? acceptations.data : null;

  const recentRejection =
    rejectionDataHistory?.data?.id !== undefined
      ? rejectionDataHistory?.data
      : null;

  return currentRejection ?? recentRejection;
};
